import React from 'react';
import { timeStringToDate } from '@powerednow/components/fields/TimePicker';
import Box from '@powerednow/components/Box/Box';
import { CHASE_DATE_BY_VALUE } from '@powerednow/shared/constants/document';
import { formatDateToHoursAndMinutes } from '@powerednow/shared/modules/utilities/date';
import textUtils from '@powerednow/shared/modules/utilities/textUtils';
import { ListItemCardProps } from 'FieldServices/react/features/workflow/ListItemCards/ListItemCardProps';
import MessageIdToMessage from './MessageIdToMessage';

function InvoiceReminderListItemCard({ workflow, index }: ListItemCardProps) {
    const sendDate = timeStringToDate(workflow.settings.reminderSendTime);

    return (
        <Box>
            <b>
                {CHASE_DATE_BY_VALUE[workflow.settings.firstReminderAfterDays]}
            </b>
            {' after the due date at '}
            <b>
                {formatDateToHoursAndMinutes(sendDate)}
            </b>
            {' when invoiced amount exceeds '}
            <b>
                {textUtils.formatMoney(workflow.settings.minimumAmountToChase)}
            </b>
            {' send a reminder using template '}
            <b>{MessageIdToMessage[workflow.settings.reminderTemplateId].NAME}</b>
        </Box>
    );
}

export default InvoiceReminderListItemCard;
